<template>
  <div>
    <div :id="echartsIdVal" :style="`height:${echartsHeight}`" class="tubiao"></div>
  </div>
</template>

<script>
export default{
  index: 'MyLine',
  props: {
    echartsIdVal: {
      type: String,
      default: ''
    },
    lineTitleName: {
      type: String,
      default: ''
    },
    echartsHeight: {
      type: String,
      default: '350px'
    },
    echartsGrid: {
      type: Object,
      default: function () {
        return {
          top: '14%',
          left: '12%',
          right: '8%',
          bottom: '10%'
        }
      }
    }
  },
  data () {
    return {
      barData: {
        name: ['2023-10-07', '2023-10-15', '2023-10-23', '2023-10-31'],
        list1: [ 3924, 2441, 2050, 2194 ],
        list2: [ 2113, 1243, 2995, 1494 ]
      },
      myBar: null
    }
  },
  mounted () {
  },
  methods: {
    setData (dataObj) {
      this.myBar = this.$echarts.init(document.getElementById(this.echartsIdVal))
      let xLabel = []
      let dataValue = []
      let dataValue1 = []
      dataObj.forEach(k => {
        xLabel.push(k.date)
        dataValue.push(k.height1st)
        dataValue1.push(k.height2nd)
      })
      this.setBar(xLabel, dataValue)
      // this.setBar(this.barData.name, this.barData.list1, this.barData.list2)
    },
    setBar (xLabel, dataValue) {
      const barOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer:
          {
            type: 'shadow',
            lineStyle: {
              color: 'rgb(2, 2, 2)'
            }
          }
        },
        legend: {
          show: true,
          top: '0',
          itemWidth: 20, // 图例标记的图形宽度。
          //   itemGap: 20, // 图例每项之间的间隔。
          itemHeight: 10, //  图例标记的图形高度。
          textStyle: {
            color: '#000',
            fontSize: 14,
            padding: [0, 4, 0, 4]
          }
        },
        grid: this.echartsGrid,
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              // 坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: 'rgb(0, 0, 0)'
              }
            },
            axisLabel: {
              // 坐标轴刻度标签的相关设置
              textStyle: {
                color: '#000000',
                fontSize: 14
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#233653'
              }
            },
            axisTick: {
              show: false
            },
            data: xLabel
          }
        ],
        yAxis: [
          {
            name: '单位(元)',
            nameTextStyle: {
              color: '#060606',
              fontSize: 14,
              padding: [0, 10, 10, 0]
            },
            // minInterval: 1,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#1160a0',
                type: 'dashed'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#000000'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#000000',
                fontSize: 12
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'line',
            symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
            smooth: true,
            lineStyle: {
              normal: {
                width: 3,
                color: '#00aaff' // 线条颜色
              }
            },
            itemStyle: {
              normal: {
                color: '#52e3ff', // 拐点颜色
                // borderColor: '#fff600',//拐点边框颜色
                // borderWidth: 13//拐点边框大小
                label: {
                  show: true, // 开启显示
                  fontSize: 14,
                  color: '#2d5ab4',
                  position: 'top', // 在上方显示
                  formatter: function (res) {
                    return parseFloat(res.value).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '元'
                    // if (res.value) {
                    //   if (res.value >= 10000) {
                    //     return parseFloat((res.value / 10000).toFixed(2)) + '万元'
                    //   } else {
                    //     return res.value + '元'
                    //   }
                    // } else {
                    //   return 0 + '元'
                    // }
                  }
                }
              }
            },
            label: {
              show: true,
              position: 'top',
              distance: 0,
              color: 'red',
              formatter: '{c}'
            },
            symbolSize: 8, // 设定实心点的大小
            areaStyle: {
              normal: {
                // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#64cdf330'
                    },
                    {
                      offset: 0.6,
                      color: '#64cdf330'
                    },
                    {
                      offset: 1,
                      color: '#64cdf330'
                    }
                  ],
                  false
                )
              }
            },
            data: dataValue
          }
        ]
      }
      this.myBar.setOption(barOption, true)
    }
  }
}
</script>

<style lang="less" scoped>
.tubiao{
  width: 100%;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/myLine.vue